import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { FadeUp } from "../components/Motion";
import { ArrowUpRight } from "lucide-react";

export default function ServicesList() {
  const { category } = useParams(); // 'residential' or 'commercial'
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get(`/services?category=${category}`).then((r) => setServices(r.data));
  }, [category]);

  const isCommercial = category === "commercial";

  return (
    <div data-testid={`services-${category}-page`} className="pt-32 pb-32">
      <section className="px-6 md:px-12 lg:px-16 mb-20">
        <FadeUp>
          <div className="overline text-[#8C1D30] mb-4">{isCommercial ? "Commercial" : "Residential"} Services</div>
          <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-none max-w-5xl">
            {isCommercial ? (
              <>Landscapes that <span className="italic text-[#D8D6D0]">elevate</span> commercial assets.</>
            ) : (
              <>Architectural <span className="italic text-[#D8D6D0]">outdoor living.</span></>
            )}
          </h1>
          <p className="text-[#D8D6D0]/60 mt-8 max-w-2xl text-lg">
            {isCommercial
              ? "Full-service commercial landscaping across Alberta — design, construction, maintenance, snow, irrigation."
              : "Premium residential design, construction, and outdoor living transformations from concept to completion."}
          </p>
        </FadeUp>
      </section>

      <section className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <FadeUp key={s.id} delay={i * 0.05}>
              <Link to={`/services/detail/${s.slug}`} data-testid={`service-${s.slug}`} className="group block nc-card overflow-hidden">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={s.image_url} alt={s.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
                </div>
                <div className="p-8">
                  <div className="font-serif-display text-2xl mb-3">{s.name}</div>
                  <p className="text-sm text-[#D8D6D0]/60 leading-relaxed">{s.short_description}</p>
                  <div className="mt-6 flex items-center gap-2 text-xs uppercase tracking-widest text-[#D8D6D0]/60 group-hover:text-[#F5F3EF] transition-colors">
                    Learn More <ArrowUpRight className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>

        <FadeUp>
          <div className="mt-20 text-center">
            <Link
              to={isCommercial ? "/contact?type=commercial" : "/estimate"}
              data-testid="services-cta"
              className="inline-flex items-center gap-2 px-10 py-5 bg-[#8C1D30] hover:bg-[#7A1829] text-[#F5F3EF] text-sm tracking-widest uppercase"
            >
              {isCommercial ? "Request Commercial Proposal" : "Get Free Estimate"} <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
